<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-11-07 16:55:54
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-06-27 11:21:18
 员工列表 显示员工信息组件
-->
<template>
  <div>
    <div class="d-flex align-center">
      <!-- <div class="d-flex"
           style="width:40px;height:40px">
        <v-img style="border-radius:50%"
               :src="getImgSrc(obj.staff_avatar)"
               class="grey lighten-2">
        </v-img>
      </div> -->
      <v-avatar left
                v-if="obj.staff_avatar||INT(obj[show_name])"
                size="32"
                style="border:1px solid rgba(0,0,0,0.1);"
                :color="colorArr[randomcolor]">
        <v-img :src="getImgSrc(obj.staff_avatar)"
               v-if="getImgSrc(obj.staff_avatar)">
        </v-img>
        <span v-else
              style="font-size:14px;text-transform:uppercase;color:#ffffff">
          {{ INT(obj[show_name])? INT(obj[show_name]).substr(0, 1):'' }}
          <!-- {{ INT(obj[show_name]).substr(0, 1) }} -->
        </span>
      </v-avatar>
      <div class="ml-4 align-center"
           style="flex:1">
        <div style="display: block;font-size: 14px;color:color: #383838;">
          {{INT(obj[show_name])?INT(obj[show_name]):''}}
          {{INT(obj[staff_code])?('('+INT(obj[staff_code])+')'):''}}
        </div>
        <div style="display: block;color: rgba(0, 0, 0, 0.38);font-size:12px;max-width:50vw;"
             class="d-flex">
          <span class="mr-2 ">
            {{INT(obj[job_post_name])}}
            <!-- {{INT(obj[job_post_name])}} {{INT(obj[job_grade_name])?'('+(INT(obj[job_grade_name]))+')':''}} -->
          </span>
          <!-- <span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
            {{INT(obj[client_name])}}{{INT(obj[org_level_all])?'>'+INT(obj[org_level_all]):''|replaceclient_and_org}}{{INT(obj[dept_name])?'>'+INT(obj[dept_name]):''|replaceclient_and_org}}
          </span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AWSS3 from '@/utils/awss3' //AWS S3
import { findSrc } from '@/service/api/upload.js'
export default {
  components: {},
  props: {
    staffObj: {}, //员工信息对象
    client_name: { //客户
      type: String,
      default: 'client_name'
    },
    dept_name: { //部门
      type: String,
      default: 'dept_name'
    },
    job_grade_name: {//岗位等级
      type: String,
      default: 'job_grade_name'
    },
    job_post_name: {//岗位
      type: String,
      default: 'job_post_name'
    },
    org_level_all: {//公司
      type: String,
      default: 'org_level_all'
    },
    show_name: {//中文名
      type: String,
      default: 'preferred_name'
    },
    staff_code: {//员工id
      type: String,
      default: 'staff_code'
    },
    staff_avatar: {//图片地址uuid或者图片内容对象
      type: [String, Object],
    },
    staff_id: {
      type: String,
      default: 'staff_id'
    },
    allList: {
      type: Array,
    },
    staffuuid: {
      type: String,
    },
    itemValue: {
      type: String,
      default: 'uuid',
    },
  },
  data () {
    return {
      colorArr: [
        '#637A88',
        '#3F9B30',
        '#289DAA',
        '#66B4E7',
        '#4354B4',
        '#7C81FC',
        'rgba(147, 76, 14)',
        '#AA3E90',
        '#FC8282',
        '#AA3E3E',
        '#ED7217',
        '#DBB016',
      ],
      randomcolor: null,
    };
  },
  filters: {
    replaceclient_and_org (val) {
      if (!val) return ''
      // return val.replaceAll('\\', '>').replaceAll('/', '>')
      return String(val).replace(/\//g, '>')
    },
  },
  computed: {
    obj () {
      if (Array.isArray(this.allList) && this.allList.length >= 0) {
        const arr = this.allList.filter((item) => {
          return item[this.itemValue] == this.staffuuid
        })
        if (arr.length > 0) {
          // arr[0].client_and_org = arr[0].client_and_org.replace('\\', '>')
          return arr[0]
        } else {
          return {}
        }
      }
      else {
        return this.staffObj
      }
    },
  },
  created () {
    this.randomcolor = Math.round(Math.random() * (this.colorArr.length - 1))
  },
  watch: {},
  mounted () { },
  methods: {
    getImgSrc (val) {
      if (typeof val == 'object'){
        if(!val.path) return ''
         return AWSS3.sign(val.path)
      }
      else if (val == '' || val == undefined) return ''
      else return AWSS3.sign(val)
      // findSrc({ 'uuid': val })
      //   .then(res => {
      //     if (res.data.files.length > 0) {
      //       return res.data.files[0].path
      //     }
      //     else {
      //       return ''
      //     }
      //   })
    }
  },
};
</script>

<style scoped>
.spans {
  /* display: flex;
  max-width: 500px;
  overflow: hidden; */
}
</style>
